// extracted by mini-css-extract-plugin
module.exports = {"promo-info":"_3ea6fa5da8--promo-info--M82ha","promo-info-text":"_3ea6fa5da8--promo-info-text--eWMjg","promo-sale-info":"_3ea6fa5da8--promo-sale-info--twOO_"};